import React, { useEffect, useState } from 'react';
import './App.scss';
import RootRoute from './routes';
import Layout from './components/Layout';
import { aesEncrypt } from 'src/utils/ase';
import { isFunctionCN } from 'src/utils/env';
import { BrowserRouter } from 'react-router-dom';
import { getGoogleClientId } from 'src/api/login';
import { generateUUID } from 'src/utils/generateUUID';
import faviconCN from 'src/assets/config/faviconCN.png';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getGuidKey, setGuidKey } from 'src/utils/localStorage';
import { TATE_HOSTNAME } from 'src/pages/Chat/components/Login/components/Google/config';

const App: React.FC = () => {
  const CLIENT_ID = '93634568035-rmrb86dji7g429simearakioe85nr0mo.apps.googleusercontent.com';
  const [clientId, setClientId] = useState<string>('');

  useEffect(() => {
    // session中没有记录guid，则生成并保存
    if (!getGuidKey()) {
      // 生成
      const guid = {
        userAgent: navigator?.userAgent ? navigator?.userAgent : 'web',
        clientType: 1,
        uuid: generateUUID()
      };
      // 加密
      const aesGuid = aesEncrypt(JSON.stringify(guid));
      // 保存
      setGuidKey(aesGuid);
    }
    // 非拓问域名地址和本地，调用后端接口获取google clientId
    if (!TATE_HOSTNAME?.includes(location.host)) {
      getGoogleConfig();
    } else {
      // 如果是拓问域名地址，则直接使用默认的google clientId
      setClientId(CLIENT_ID);
    }
    // 设置国内版图标
    if (isFunctionCN()) {
      document.title = '拓问';
      let faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement ||
                    document.querySelector('link[rel="shortcut icon"]') as HTMLLinkElement;
      if (!faviconLink) {
        faviconLink = document.createElement('link');
        faviconLink.rel = 'icon';
        document.head.appendChild(faviconLink); // 加到head中
      }
      faviconLink.href = faviconCN;
    }
  }, []);

  const getGoogleConfig = async () => {
    try {
      const res: Record<string, any> = await getGoogleClientId({ customDomain: location.host });
      setClientId(res?.object?.clientId || CLIENT_ID);
    } catch (error) {}
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <Layout>
          <RootRoute/>
        </Layout>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
